import { render, staticRenderFns } from "./ReleaseNote.vue?vue&type=template&id=d87c9468&"
import script from "./ReleaseNote.vue?vue&type=script&lang=js&"
export * from "./ReleaseNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports